<div class="card">
  <div class="card-header">
    APPENDIX Q TECHNOLOGY
  </div>
  <div class="card-body">
    <form [formGroup]="technologyForm" novalidate>

      <div class="mh-16 mv-8 w-400">
        <label for="description" class="form-label">Description</label>
        <input type="text" id="description" class="form-control" formControlName="appendixQDescription">
      </div>

      <div class="mh-16 mv-8 w-400">
        <label for="specialFeatureTypeEmissions" class="form-label">Special Feature Type (Emmissions)</label>
        <select id="specialFeatureTypeEmissions" class="form-select" formControlName="specialFeatureTypeEmissions">
          <option *ngFor="let lookupCode of filterLookupCodes('HeatingFuelTypeCode')" [value]="lookupCode.lookupValue">
              {{ lookupCode.lookUpItem }}
          </option>
        </select>
      </div>

      <div class="row" *ngIf="isEmissionsFeatureSelected">
        <div class="mh-16 mv-8 w-400">
          <label for="emissionsSaved" class="form-label">Emissions Saved (kgCO2)</label>
          <input type="number" id="emissionsSaved" class="form-control" formControlName="appendixQEmissionsSaved">
        </div>

        <div class="mh-16 mv-8 w-400">
          <label for="emissionsCreated" class="form-label">Emissions Created (kgCO2)</label>
          <input type="number" id="emissionsCreated" class="form-control" formControlName="appendixQEmissionsCreated">
        </div>
      </div>

      <hr />
      <div class="mh-16 mv-8 w-400">
        <label for="specialFeatureTypeEnergy" class="form-label">Special Feature Type (Energy)</label>
        <select id="specialFeatureTypeEnergy" class="form-select" formControlName="specialFeatureTypeEnergy">
          <option *ngFor="let lookupCode of filterLookupCodes('HeatingFuelTypeCode')" [value]="lookupCode.lookupValue">
              {{ lookupCode.lookUpItem }}
          </option>
        </select>
      </div>

      <div  *ngIf="isEnergyFeatureSelected">
        <div class="mh-16 mv-8 w-400">
          <label for="energySavedOrGenerated" class="form-label">Energy saved or generated (kWh/year)</label>
          <input type="number" id="energySavedOrGenerated" class="form-control" formControlName="appendixQEnergySaved">
        </div>
        <div class="mh-16 mv-8 w-400">
          <label for="appendixQEnergySavedFuel" class="form-label">Saved or Generated Fuel</label>
          <select id="appendixQEnergySavedFuel" class="form-select" formControlName="appendixQEnergySavedFuel">
            <option *ngFor="let lookupCode of filterLookupCodes('HeatingFuelTypeCode')" [value]="lookupCode.lookupValue">
                {{ lookupCode.lookUpItem }}
            </option>
          </select>
        </div>

        <div class="mh-16 mv-8 w-400">
          <label for="energyUsed" class="form-label">Energy used (kWh/year)</label>
          <input type="number" id="energyUsed" class="form-control" formControlName="appendixQEnergyUsed">
        </div>


        <div class="mh-16 mv-8 w-400">
          <label for="appendixQEnergyUsedFuel" class="form-label">Energy Used Fuel</label>
          <select id="appendixQEnergyUsedFuel" class="form-select" formControlName="appendixQEnergyUsedFuel">
            <option *ngFor="let lookupCode of filterLookupCodes('HeatingFuelTypeCode')" [value]="lookupCode.lookupValue">
                {{ lookupCode.lookUpItem }}
            </option>
          </select>
        </div>

        <div class="mh-16 mv-8 w-400">
          <div class="form-check">
            <label class="form-check-label" for="airChangeRatesCheck">
              Air Change Rates
            </label>
            <input class="form-check-input" type="checkbox" id="airChangeRatesCheck" formControlName="appendixQEnergyAirChangeRates">
          </div>
          <div formArrayName="appendixQEnergyAirChangeRateMonth" class="row">
            <div *ngFor="let monthGroup of airChangeRateMonths?.controls; let i = index" [formGroupName]="i" class="col-6 col-md-2 mb-2">
              <label [for]="'airChangeRate' + i" class="form-label">{{monthGroup.get('month').value}}</label>
              <input type="number" [id]="'airChangeRate' + i" class="form-control" formControlName="airChangeRateValue">
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
